<template>
  <div 
    class="xit-fb-template node sequence"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-fill-drip card-start-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      <div class="card-data" v-if="node.data.name">
        <p v-if="node.data.name" class="text-center mb-2 postback_title">
          {{ node.data.name }}
        </p>

        <div class="list-group mt-2">
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.startingTime && node.data.closingTime">         
            <small class="text-muted">{{ start_time }}</small>
            <p class="mb-0"> {{ node.data.startingTime }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.startingTime && node.data.closingTime">         
            <small class="text-muted">{{ closing_time }}</small>
            <p class="mb-0"> {{ node.data.closingTime }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.timezone">         
            <small class="text-muted">{{ timezone }}</small>
            <p class="mb-0"> {{ node.data.timezone }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.messageTag">         
            <small class="text-muted">{{ message_tag }}</small>
            <p class="mb-0"> {{ node.data.messageTagText }}</p>
          </span>
        </div>
      </div>
      <div v-else class="double-click-div text-center">
        <img :src="icon_doubletap" :title="double_click_for_settings">
      </div>

      <div class="card-sockets">
        <div class="output text-right float-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
          <div class="output-title">{{output.name}}</div>
          <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
        </div>
        <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
          <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
          <div class="input-title">{{input.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'

import { lang } from '../../assets/lang'
import { templateComponentMethods } from '../../utils/functions'

export default {
  name: 'SequenceTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    start_time: lang.sequence_template_start_time,
    closing_time: lang.sequence_template_closing_time,
    timezone: lang.sequence_template_timezone,
    message_tag: lang.sequence_template_message_tag,
    double_click_for_settings: lang.double_click_for_settings,
    icon_doubletap: window.xitFlowBuilderData.icon_doubletap,
  }),

  methods: {
    ...templateComponentMethods,

    getSelectedLabelTexts(node) {
      const labelIdTextsArray = node.data.labelIdTextsArray || []
      return labelIdTextsArray.join(', ')
    }
  },
}
</script>